<template>
    <div class="card-wrap"
      @mousemove="handleMouseMove"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      ref="card">
      <div class="p-card"
        :style="{ transform: `rotateY(${mouseX * p30overWidth}deg) rotateX(${mouseY * m30overHeight}deg)` }">
        <div class="card-bg" :style="[{ transform: `translateX(${mouseX * m40overWidth}px) translateY(${mouseY * m40overHeight}px)` }, 
          { backgroundImage: `url(${dataImage})` }]"></div>
        <div class="card-info">
          <slot name="header"></slot>
          <slot name="content"></slot>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    mounted() {
    this.width = this.$refs.card.offsetWidth;
    this.height = this.$refs.card.offsetHeight;
    this.offsetHalfWidth = 0 - this.$refs.card.offsetLeft - this.width / 2;
    this.offsetHalfHeight = 0 - this.$refs.card.offsetTop - this.height / 2;
    this.p30overWidth = 30 / this.width;
    this.m30overHeight = 0 - 30 / this.height;
    this.m40overWidth = 0 - 40 /this.width;
    this.m40overHeight = 0 - 40 / this.height;
  },
  props: ['dataImage'],
  data: () => ({
    width: 0,
    height: 0,
    offsetHalfWidth: 0,
    offsetHalfHeight: 0,
    p30overWidth: 0,
    m30overHeight: 0,
    m40overWidth: 0,
    m40overHeight: 0,
    heightTimes30: 0,
    mouseX: 0,
    mouseY: 0,
    mouseLeaveDelay: null
  }),
  methods: {
    handleMouseMove(e) {
      this.mouseX = e.pageX + this.offsetHalfWidth;
      this.mouseY = e.pageY + this.offsetHalfHeight;
    },
    handleMouseEnter() {
      clearTimeout(this.mouseLeaveDelay);
    },
    handleMouseLeave() {
      this.mouseLeaveDelay = setTimeout(()=>{
        this.mouseX = 0;
        this.mouseY = 0;
      }, 1000);
    }
  }
}
</script>

<style lang="scss" scoped>
    $hoverEasing: cubic-bezier(0.23, 1, 0.32, 1);
    $returnEasing: cubic-bezier(0.445, 0.05, 0.55, 0.95);

    p {
        line-height: 1.5em;
    }

    a {
        color: white;
        text-decoration: none;
    }

    h1+p, p+p {
        margin-top: 10px;
    }

    .card-wrap {
        margin: 10px;
        transform: perspective(800px);
        transform-style: preserve-3d;
        // background-color: #fff;
    
        &:hover {
            .card-info {
                transform: translateY(0);
            }
            .card-info p {
                opacity: 1;
            }
            .card-info, .card-info p {
                transition: 0.6s $hoverEasing;
            }
            .card-info:after {
                transition: 1s $hoverEasing;
                opacity: 1;
                transform: translateY(0);
            }
            .card-bg {
                transition: 
                    0.6s $hoverEasing,
                    opacity 1s $hoverEasing;
                opacity: 1;
            }
            .p-card {
                transition:
                    0.6s $hoverEasing,
                    box-shadow 1s $hoverEasing;
                box-shadow:
                    rgba(white, 0.2) 0 0 40px 5px,
                    rgba(white, 1) 0 0 0 1px,
                    rgba(black, 0.66) 0 30px 60px 0,
                    inset #333 0 0 0 5px,
                    inset white 0 0 0 6px;
                }
        }
    }

    .p-card {
        position: relative;
        flex: 0 0 240px;
        width: 240px;
        height: 320px;
        background-color: #333;
        overflow: hidden;
        border-radius: 10px;
        box-shadow:
            rgba(black, 0.66) 0 30px 60px 0,
            inset #333 0 0 0 5px,
            inset rgba(white, 0.5) 0 0 0 6px;
        transition: 1s $returnEasing;
    }

    .card-bg {
        opacity: 0.5;
        position: absolute;
        top: -20px; left: -20px;
        width: 120%;
        height: 120%;
        padding: 20px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        transition:
            1s $returnEasing,
            opacity 5s 1s $returnEasing;
        pointer-events: none;
    }

    .card-info {
        width: 100%;
        padding: 20px;
        position: absolute;
        bottom: 0;
        color: #fff;
        transform: translateY(40%);
        transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
    
        p {
            opacity: 0;
            min-height: 50px;
            text-shadow: rgba(black, 1) 0 2px 3px;
            transition: 0.6s 1.6s cubic-bezier(0.215, 0.61, 0.355, 1);
        }
        
        * {
            position: relative;
            z-index: 1;
        }
        
        &:after {
            content: '';
            position: absolute;
            top: 0; left: 0;
            z-index: 0;
            width: 100%;
            height: 100%;
            background-image: linear-gradient(to bottom, transparent 0%, rgba(#000, 0.6) 100%);
            background-blend-mode: overlay;
            opacity: 0;
            transform: translateY(100%);
            transition: 5s 1s $returnEasing;
        }
    }

    .card-info h1 {
        font-family: "Playfair Display";
        font-size: 36px;
        font-weight: 700;
        text-shadow: rgba(black, 0.5) 0 10px 10px;
    }
</style>